import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchJSON, apiRootEndpoint } from '../../helpers';
import {
    GET_APPRAISALS, 
    SUBMIT_APPRAISAL_FORM,
    DELETE_APPRAISAL,
    GET_CURRENT_APPRAISAL,
    DOWNLOAD_APPRAISAL
} from '../../constants/actionTypes';


import {
    getAllAppraisalsSuccess,
    getAllAppraisalsFailed,

    submitAppraisalFormSuccess,
    submitAppraisalFormFailed,

    deleteAppraisalSuccess,
    deleteAppraisalFailed,

    getCurrentAppraisalSuccess,
    getCurrentAppraisalFailed,

    downloadAppraisalSuccess,
    downloadAppraisalFailed
} from './actions';

const apiUrl = `${apiRootEndpoint}/api/v1/appraisals`;

function* getAllAppraisals({ payload: { offset, limit, filter } }) {
    const options = {
        method: 'GET',
    };
    
    try {
        let url = `${apiUrl}?offset=${offset}&limit=${limit}`;
        if(filter.query) {
            url = `${url}&query=${filter.query}`
        }
        if(filter.employeeId) {
            url = `${url}&employeeId=${filter.employeeId}`;
        }
        if(filter.appraiserId) {
            url = `${url}&appraiserId=${filter.appraiserId}`;
        }
        const {total, data} = yield call(fetchJSON, url, options);
        yield put(getAllAppraisalsSuccess({total, data}));
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(getAllAppraisalsFailed(message));
    }
}

function* submitAppraisal({ payload: item }) {
    const options = {
        body: JSON.stringify(item),
        method: item.id ? 'PUT' :  'POST',
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        let url = `${apiUrl}`;
        if(item.id) {
            url = `${apiUrl}/${item.id}`;
        }
        const response = yield call(fetchJSON, url, options);
        if(response.status === 'OK') {
            yield put(submitAppraisalFormSuccess(response.data));
        }
        else {
            yield put(submitAppraisalFormFailed(response.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(submitAppraisalFormFailed(message));
    }
}

function* deleteAppraisal({ payload: id }) {
    const options = {
        method: 'DELETE',
    };
    try {
        const url = `${apiUrl}/${id}`;
        const response = yield call(fetchJSON, url, options);
        
        if(response.status === "OK") {
            yield put(deleteAppraisalSuccess(id));
        }
        else {
            yield put(deleteAppraisalFailed(response.message));
        }
    } catch (error) {
       
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(deleteAppraisalFailed(message));
    }
}

function* getCurrentAppraisal({ payload: id }) {
    const options = {
        method: 'GET',
    };
    
    try {
        let url = `${apiUrl}/${id}`;
       
        const appraisal = yield call(fetchJSON, url, options);
        yield put(getCurrentAppraisalSuccess(appraisal.data));
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(getCurrentAppraisalFailed(message));
    }
}



function* downloadAappraisal({ payload: {id, type} }) {
    const options = {
        method: 'GET',
    };
    try {
        let url = `${apiUrl}/${id}/download`;
        if(type) {
            url = `${url}?type=${type}`
        }
        const response = yield call(fetchJSON, url, options);
        
        if(response.status === "OK") {
            if(response.url) {
                window.open(response.url);
            }
            yield put(downloadAppraisalSuccess());
        }
        else {
            yield put(downloadAppraisalFailed(response.message));
        }
    } catch (error) {
       
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(downloadAppraisalFailed(message));
    }
}




export function* watchGetAllAppraisals() {
    yield takeEvery(GET_APPRAISALS, getAllAppraisals);
}
export function* watchSubmitAppraisalForm() {
    yield takeEvery(SUBMIT_APPRAISAL_FORM, submitAppraisal);
}
export function* watchDeleteAppraisal() {
    yield takeEvery(DELETE_APPRAISAL, deleteAppraisal);
}
export function* watchGetCurrentAppraisal() {
    yield takeEvery(GET_CURRENT_APPRAISAL, getCurrentAppraisal);
}
export function* watchDownloadAppraisal() {
    yield takeEvery(DOWNLOAD_APPRAISAL, downloadAappraisal);
}

function* appraisalSaga() {
    yield all([
        fork(watchGetAllAppraisals),
        fork(watchSubmitAppraisalForm),
        fork(watchDeleteAppraisal),
        fork(watchGetCurrentAppraisal),
        fork(watchDownloadAppraisal),
    ]);
}

export default appraisalSaga;